import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserHasAccess, PermissionName} from './currentUserHasAccess';

export const currentUserHasAssetAttributeAccess = (): boolean => {
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.EDIT_ATTRIBUTE_VALUES);
};
